import './BuilderSearch.scss';
import template from './BuilderSearchView.html';
import { EventEmitter } from 'modules/shared/EventEmitter';
export const TOGGLE_SEARCH = 'TOGGLE_SEARCH';
class BuilderSearchController {
    static $inject = ['$scope', '$element'];
    constructor($scope, $element) {
        'ngInject';
        this.$scope = $scope;
        this.$element = $element;
        this.showSearch = false;
        this.inputText = '';
        this.onBlur = () => {
            if (this.inputText.length === 0) {
                this.onGetInput(EventEmitter({ input: '' }));
            }
        };
        this.onInputChange = ({ detail: { value } }) => {
            this.inputText = value;
            this.onGetInput(EventEmitter({ input: this.inputText }));
        };
        this.checkClicksOutsideScope = (event) => {
            if (this.inputText) {
                return;
            }
            const onScope = event.target.querySelector('#builder-search') ||
                event.target.id === 'builder-search' ||
                event.target.id === 'builder-search-tooltip';
            !onScope && this.clearSearch();
        };
    }
    clearSearch() {
        this.inputText = '';
        this.onGetInput(EventEmitter({ input: '' }));
        this.showSearch = false;
        document.removeEventListener('click', this.checkClicksOutsideScope);
        const el = this.$element[0];
        const input = el.querySelector('input');
        input && input.blur();
    }
    listenBroad() {
        this.searchListener = this.$scope.$on(TOGGLE_SEARCH, (event, { showSearch }) => {
            if (typeof showSearch === 'boolean') {
                this.clearSearch();
                this.showSearch = showSearch;
                this.searchListener();
                this.searchListener = undefined;
            }
            else {
                console.error('not a boolean');
            }
        });
    }
    toggleSearch() {
        if (!this.showSearch) {
            const el = this.$element[0];
            const input = el.querySelector('input');
            input && input.focus();
            this.showSearch = true;
            !this.searchListener && this.listenBroad();
            setTimeout(() => {
                document.addEventListener('click', this.checkClicksOutsideScope);
            });
        }
        else {
            this.clearSearch();
        }
    }
}
BuilderSearchController.$inject = ['$scope', '$element'];
export const BuilderSearchComponent = {
    controller: BuilderSearchController,
    controllerAs: '$ctrl',
    bindings: {
        onGetInput: '&?',
    },
    template,
};
